import { Validator } from "@saas/shared/utils/^type/validator";

import isEmail from "validator/lib/isEmail";

export type TRegisterLoyaltyFormValues = {
  name: string;
  email: string;
  password: string;
  confirmPassword: string;
  phone: string;
  birthdate?: string;
  isTncChecked: boolean;
};

interface TRegisterLoyaltyValidation
  extends Omit<Validator<TRegisterLoyaltyFormValues>, "confirmPassword"> {
  confirmPassword: (value: string, password: string) => string | boolean;
}

export const registerLoyaltyValidation: TRegisterLoyaltyValidation = {
  email: (value) => {
    if (!isEmail(value)) {
      return "Harap isi dengan format yang benar.";
    }

    return true;
  },
  password: (value) => {
    const MINIMUM_LENGTH = 8;

    const hasNumber = /\d/.test(value);
    const hasCharacter = /[a-zA-Z]/.test(value);
    const hasMinimumLength = value.length >= MINIMUM_LENGTH;

    return hasCharacter && hasNumber && hasMinimumLength
      ? true
      : "Min. 8 karakter, harus kombinasi dari huruf dan angka.";
  },
  confirmPassword: (value, password) => {
    if (value !== password) return "Belum sesuai dengan kata sandi.";

    return true;
  },
  phone: (value) => {
    const withoutPrefix = value.replace("+62", "");

    if (withoutPrefix.length < 10 || withoutPrefix.length > 12) {
      return "Nomor telepon tidak boleh kurang dari 10 atau lebih dari 12 karakter.";
    }

    return true;
  },
};
